import { isPositiveNumber } from "et3-type-guards";
import i18n from "../../../../../../constants/i18n";
import getKhattabatStore from "../../../../../../stores/khattabat-stores";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import {
  TSelectionPages,
  TalkhattabatConversationType
} from "../../../../../../Types";

const MarkAsReadButton = withLiteObserverAndTheme<{
  unreadOneOOneCMessages: number;
  alkhattabaUUID: string;
  clientUUID: string;
  clientID: number;
  pageType: TSelectionPages;
  conversationType: TalkhattabatConversationType;
}>((props) => {
  const {
    theme,
    alkhattabaUUID,
    clientUUID,
    unreadOneOOneCMessages,
    clientID,
    pageType,
    conversationType
  } = props;
  const { colors, unitX } = theme;
  const shouldShow =
    isPositiveNumber(unreadOneOOneCMessages) &&
    !(conversationType === "101C_COMMENTS");

  return !shouldShow ? null : (
    <ET3Div
      width={180}
      height={43}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        backgroundColor: colors.all.darkOrange,
        borderRadius: 36 * unitX,
        cursor: "pointer"
      }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={async () => {
        getKhattabatStore().setOneOOneMessagesSeen({
          alkhattabaUUID,
          clientUUID,
          clientID,
          pageType
        });
      }}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={24}
        isSpan={false}
        text={i18n.get("MARK_AS_READ")}
        style={{}}
        color={colors.all.white}
      />
    </ET3Div>
  );
});

export default MarkAsReadButton;
